// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';
import { protokoll } from './lib/protokoll';

// Vite stellt Umgebungsvariablen über import.meta.env bereit. Die alten
// REACT_APP_-Namen bleiben gültig (siehe envPrefix in vite.config.js), damit
// bestehende .env-Dateien unverändert weiterlaufen.
const env = import.meta.env;

const supabaseUrl = env.VITE_SUPABASE_URL || env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey =
  env.VITE_SUPABASE_ANON_KEY ||
  env.REACT_APP_SUPABASE_DEFAULT_KEY ||
  env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

export const supabaseConfigError =
  !supabaseUrl || !supabaseAnonKey
    ? 'Supabase-Umgebungsvariablen fehlen. Setze VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY (die alten REACT_APP_-Namen funktionieren weiterhin).'
    : null;

if (supabaseConfigError) {
  protokoll.fehler('Konfiguration', 'Supabase ist nicht eingerichtet', supabaseConfigError);
}

export const supabase = supabaseConfigError ? null : createClient(supabaseUrl, supabaseAnonKey);
